import { Component, EventEmitter, Input, Output } from '@angular/core'

import { ResponsiveComponent } from '@nx-superprep/shared'

import { FrontendCard as Card, Choice, StudyPhase, StudySetting } from '@nx-superprep/backend/firebase'

import { TilesComponent } from "../tiles/tiles.component"
import { StackComponent } from "../stack/stack.component"
import { NumbersComponent } from "../numbers/numbers.component"
import { PeriodicComponent } from "../periodic/periodic.component"
import { DiagramComponent } from "../diagram/diagram.component"
import { FillComponent } from "../fill/fill.component"
import { FlipComponent } from "../flip/flip.component"
import { NgStyle } from '@angular/common'

@Component({
  standalone: true,
  selector: 'gameplay-player-ngx',
  templateUrl: './gameplay-player-ngx.component.html',
  styleUrls: ['./gameplay-player-ngx.component.scss'],
  imports: [
    TilesComponent,
    StackComponent,
    NumbersComponent,
    PeriodicComponent,
    DiagramComponent,
    FillComponent,
    FlipComponent,
    NgStyle,
  ],
})
export class GameplayPlayerNGXComponent extends ResponsiveComponent {
  @Input() setting!: StudySetting
  @Input() phase!: StudyPhase
  @Input() progress = 0
  @Input() isAutoplay = false
  @Input() didAnswer = false
  @Input() card: Card|undefined
  @Output() selected = new EventEmitter<Choice>()
  @Output() action = new EventEmitter<string>()

  onSelect(choice?: Choice): void {
    if (!choice) { return }
    this.selected.emit(choice)
  }
}
